import { createFileRoute } from '@tanstack/react-router';

import { dashboardRouteSearchSchema as publisherDashboardRouteSearchSchema } from '../features/dashboard/dashboardRouteSearch';
import { PublisherDashboardContent } from '../features/publisher/dashboard/PublisherDashboardPage';

export const Route = createFileRoute('/supply/publishers_/$publisherId/details/overview')({
  validateSearch: publisherDashboardRouteSearchSchema,
  component: PublisherOverviewRoute,
});

function PublisherOverviewRoute() {
  const { publisherId } = Route.useParams();
  return <PublisherDashboardContent publisherId={publisherId} detailsMode />;
}
